import { SortOrder } from "@common/constants";
import {
    TransactionSort,
    TransactionsQuerySortField,
} from "@common/schemas/transaction.schema";
import { InvoiceSort } from "@common/types/invoice";
import { BillSort } from "@common/types/bill";
import { AccrualMatchSortValue } from "./types";

function parseAccrualMatchSortValue(value: AccrualMatchSortValue): {
    field:
        | "date"
        | "counterparty"
        | "description"
        | "account"
        | "class"
        | "amount";
    order: SortOrder;
} {
    switch (value) {
        case AccrualMatchSortValue.DATE_ASC:
            return { field: "date", order: SortOrder.ASC };
        case AccrualMatchSortValue.DATE_DESC:
            return { field: "date", order: SortOrder.DESC };
        case AccrualMatchSortValue.COUNTERPARTY_ASC:
            return { field: "counterparty", order: SortOrder.ASC };
        case AccrualMatchSortValue.COUNTERPARTY_DESC:
            return { field: "counterparty", order: SortOrder.DESC };
        case AccrualMatchSortValue.DESCRIPTION_ASC:
            return { field: "description", order: SortOrder.ASC };
        case AccrualMatchSortValue.DESCRIPTION_DESC:
            return { field: "description", order: SortOrder.DESC };
        case AccrualMatchSortValue.ACCOUNT_ASC:
            return { field: "account", order: SortOrder.ASC };
        case AccrualMatchSortValue.ACCOUNT_DESC:
            return { field: "account", order: SortOrder.DESC };
        case AccrualMatchSortValue.CLASS_ASC:
            return { field: "class", order: SortOrder.ASC };
        case AccrualMatchSortValue.CLASS_DESC:
            return { field: "class", order: SortOrder.DESC };
        case AccrualMatchSortValue.AMOUNT_ASC:
            return { field: "amount", order: SortOrder.ASC };
        case AccrualMatchSortValue.AMOUNT_DESC:
            return { field: "amount", order: SortOrder.DESC };
    }
}

export function accrualMatchSortToTransactionSort(
    value: AccrualMatchSortValue,
): TransactionSort | undefined {
    const { field, order } = parseAccrualMatchSortValue(value);
    switch (field) {
        case "date":
            return { field: TransactionsQuerySortField.DATE, order };
        case "counterparty":
            return { field: TransactionsQuerySortField.COUNTERPARTY, order };
        case "description":
            return {
                field: TransactionsQuerySortField.BANK_DESCRIPTION,
                order,
            };
        case "account":
            return {
                field: TransactionsQuerySortField.FINANCIAL_ACCOUNT,
                order,
            };
        case "class":
            return { field: TransactionsQuerySortField.CLASS, order };
        case "amount":
            return { field: TransactionsQuerySortField.AMOUNT, order };
        default:
            return undefined;
    }
}

function accrualMatchSortToDocumentSort(
    value: AccrualMatchSortValue,
): { field: string; order: SortOrder } | undefined {
    const { field, order } = parseAccrualMatchSortValue(value);
    switch (field) {
        case "date":
            return { field: "date", order };
        case "counterparty":
            return { field: "counterparty", order };
        case "account":
            return { field: "account", order };
        case "amount":
            return { field: "amount", order };
        default:
            return undefined;
    }
}

export function accrualMatchSortToInvoiceSort(
    value: AccrualMatchSortValue,
): InvoiceSort | undefined {
    return accrualMatchSortToDocumentSort(value);
}

export function accrualMatchSortToBillSort(
    value: AccrualMatchSortValue,
): BillSort | undefined {
    return accrualMatchSortToDocumentSort(value);
}
